import styled from "rn-css";
import { TouchableWithoutFeedback } from "react-native";

interface Props {
	onPress?: () => void;
	isMqtt?: boolean;
}

const StyledNerdButton = styled.View<Props>`
	position: absolute;
	background-color: transparent;
	width: 60px;
	height: 60px;
	bottom: 0;
	${(props: Props) => (props?.isMqtt ? "left: 0;" : "right: 0;")}
`;

const NerdButton = (props: Props) => {
	return (
		<TouchableWithoutFeedback onPress={props.onPress}>
			<StyledNerdButton isMqtt={props?.isMqtt}></StyledNerdButton>
		</TouchableWithoutFeedback>
	);
};

export default NerdButton;
